export function load() {
    return import("./module-loader");
}
